import React, { useState, useEffect, memo } from 'react'
import './Accordion.css'
import {HiFolder} from "react-icons/hi";
import { makeStyles } from '@material-ui/core/styles';
import * as Actions from 'app/store/actions';


import { useDispatch } from 'react-redux';
import {useTranslation} from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import clsx from 'clsx';
import { getWeather } from 'app/main/pages/dashboards/userWithProjectSelected/weather/actions/weatherActions';


const useStyles = makeStyles(theme => ({ 
    contentAnchor:{
        display:'flex',
        width:'100%',
        lineHeight:'40px',
        alignItems:'center',
        borderRadius:'5px',
        padding:'0 10px',
        cursor:'pointer',
        '&:hover':{
            backgroundColor:'rgba(73, 127, 177, 0.11)',
            color:`${theme.palette.background.paper}!important`,
        }
    },
    contentSelected:{
        display:'flex',
        width:'100%',
        lineHeight:'40px',
        alignItems:'center',
        borderRadius:'5px',
        padding:'0 10px',
        cursor:'pointer',
        backgroundColor:'rgba(73, 127, 177, 0.11)',
        color:`${theme.palette.background.paper}!important`,
    },
    txtStyle:{
        color:theme.palette.scaiPro.text,
        fontSize: '1.2rem',
        flex: 1,
		overflow: 'hidden',
		minWidth: 0,
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
    },
    folderStyle:{
        color: `${theme.palette.scaiPro.secondary}!important`,
        fontSize: '20px',
        marginRight: '10px',
    },
    accordionInsideBox:{
        maxHeight: '190px',
        overflow: 'auto',
    },
    boxCode:{
        color:theme.palette.scaiPro.text,
        fontSize: '1rem',
        marginTop:'-20px',
        marginLeft:'30px',
    },
    txtCode:{
        color: theme.palette.scaiPro.primary,
        marginRight:'5px',
    }

}))

/** CONTENT FOR THE FIRST ACCORDION COMPONENT */
/** You can change content if you want */

function Content(props) {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const { i18n } = useTranslation();
    const {t} = useTranslation('sharedComponentsPage');
    //const project = useSelector(({ members }) => members);
    const dispatch = useDispatch();
    //const members_getProjects = useSelector(({ projectSelectorApp }) => projectSelectorApp.members.members_getProjects);
    const [currentProject, setCurrentProject] = useState('');
    const companyID =  JSON.parse(localStorage.getItem('persistCompanyID'));
    const projectSelectedValues =  JSON.parse(localStorage.getItem('persistProjectSelected'));

    // const newSelectedProject = props.projectBranch.filter((ele) => {
    //     return (ele.projectName?.toLowerCase()).includes(props.searchText.toLowerCase()) 
    // });

    useEffect(()=>{
        dispatch(Actions.handleMembers_projectSelected(JSON.parse(localStorage.getItem('persistProjectSelected'))));
        currentProject && localStorage.setItem('persistProjectUUID', currentProject.uuid);
        currentProject && dispatch(Actions.getNoticeBoard());
        
        if (i18n.language === 'jp') {
            currentProject && dispatch(getWeather('ja'));
        } else if(i18n.language === 'en'){
			currentProject && dispatch(getWeather('en'));
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[currentProject, i18n.language]);


    //::Selecting Project
    const handleProjectSelected = (ele) =>{
        //Redirect to Dashboard
        if(location.pathname === '/dashboard/map'){
            history.push({pathname:'/project-info'})
        }
        setCurrentProject(ele);
        localStorage.setItem('persistProjectSelected', JSON.stringify(ele));
        dispatch(Actions.handleMembers_projectSelected(ele));
        dispatch(Actions.members_selectedProjectName(ele.projectName));
        dispatch(Actions.getMembers(companyID, ele.uuid));
        dispatch(Actions.getSideMenuItems());
        setTimeout(()=>{
            dispatch(Actions.getSideMenuItems());
        },500);
    }

    // useEffect(()=>{
    //     console.log('Projects from this USER ==== >>> ', newSelectedProject)
    // })

    return (
        <div className={clsx('w-full', classes.accordionInsideBox)}>
            {
                props.projectBranch.map((ele) => {
                    return (
                            <a href={() => false}style={{textDecoration: 'none'}} key={ele.uuid} onClick={()=>handleProjectSelected(ele)} className={projectSelectedValues && ele.projectName === projectSelectedValues.projectName ? classes.contentSelected : classes.contentAnchor} >
                                <div className='flex flex-col'>
                                    <div className='inline-flex w-full items-center'>
                                        <HiFolder className={classes.folderStyle}/> 
                                        <span className={classes.txtStyle}>{ele.projectName}</span>
                                    </div>
                                    <div className={clsx('inline-flex w-full', classes.boxCode)}> 
                                        {ele.projectCode ? 
                                                <>
                                                    <span className={clsx(classes.txtCode)}>{t('project_code')}</span> 
                                                    <span>{ele.projectCode}</span>
                                                </>
                                        : null}
                                    </div>
                                </div>
                                    
                            </a>
                        );
                })
            }

            {/* {
                newSelectedProject.map((ele, key) => {
                    return (
                            <a style={{textDecoration: 'none'}} key={ele.uuid} onClick={()=>handleProjectSelected(ele)} className={projectSelectedValues && ele.projectName === projectSelectedValues.projectName ? classes.contentSelected : classes.contentAnchor} >
                                <HiFolder className={classes.folderStyle}/> <span className={classes.txtStyle}>{ele.projectName}</span>
                            </a>
                        );
                })
            } */}
        </div>
    )
}

export default memo(Content);
